import { Box, Stack, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { PhysicianDocument } from 'src/services/apiServices/physician-service/physician-service';
import { DocumentIcons } from 'src/pages/therapist-dashboard/dashboard-icon';
import { calculateDaysRemaining, formatServiceDate } from '../utils/dates';
import { formatString } from '../utils/strings';

export const DocumentTypeCell: FC<{ document: PhysicianDocument }> = ({ document }) => (
  <Stack
    alignItems="center"
    direction="row"
    spacing={1}
  >
    <Grid
      container
      sx={{ alignItems: 'center' }}
    >
      <Box sx={{ marginRight: '4px', marginTop: '7px' }}>
        <DocumentIcons iconType={document?.formType?.split('_')?.[0]?.toLowerCase()} />
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Typography variant="subtitle2">
          {document?.documentType ? formatString(document?.documentType) : '-'}
        </Typography>
      </Box>
    </Grid>
  </Stack>
);

export const DateOfServiceCell: FC<{ dateOfService: string }> = ({ dateOfService }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <Typography variant="subtitle2">
      {dateOfService ? formatServiceDate(dateOfService) : '-'}
    </Typography>
  </Box>
);

export const DaysRemainingCell: FC<{ dateOfService: string }> = ({ dateOfService }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
    <Typography
      sx={{ color: '#6C737F', textAlign: 'center' }}
      variant="caption"
    >
      {dateOfService ? calculateDaysRemaining(dateOfService) : '-'}
    </Typography>
  </Box>
);

export const ActionButtons: FC<{ onPreview: () => void }> = ({ onPreview }) => (
  <>
    <Typography
      variant="subtitle2"
      sx={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={onPreview}
    >
      Open Doc
    </Typography>
  </>
);
